import { render, staticRenderFns } from "./UserBidStatusComp.vue?vue&type=template&id=928cc66c&scoped=true"
import script from "./UserBidStatusComp.vue?vue&type=script&lang=js"
export * from "./UserBidStatusComp.vue?vue&type=script&lang=js"
import style0 from "./UserBidStatusComp.vue?vue&type=style&index=0&id=928cc66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928cc66c",
  null
  
)

export default component.exports